import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import { size, toArray } from 'lodash';


import {
    Row,
    Col,
    Card,
    Container,
    ListGroup,
    Form,
    Button,
    OverlayTrigger,
    Tooltip,
} from "react-bootstrap";
import { Spin, Progress } from "antd";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    setUploadFile,
} from "../../../../actions/CM/cm_close_loop/scenarioCarMakerFileUpload/uploadFileEnhanced";

import {
    resetFileUpload,
} from "../../../../actions/scenarioFileUpload/uploadBulkFiles";
import {
    fetchSimulatorInfo,
    fetchModelInfo,
} from "../../../../actions/CM/cm_close_loop/scenarioCarMakerCollection/dropDownModalAction";


import UploadProgress from "./uploadProgress/uploadProgressEnhanced";
import UtilityFormModal from "../scenarioCarMakerFileUpload/modal/utilityFormModal";
import {
    uploadInputFilesForValidation,
    extractImagesAndDescription,
    // uploadBulkScenarioFiles,
    resetExtractImagesAndDescription,
    resetUploadStatus
} from "../../../../actions/CM/cm_close_loop/scenarioCarMakerFileUpload/uploadBulkFiles";
import UploadBulkInputProgress from "./uploadProgress/uploadBulkInputProgress";
import { uploadBulkScenarioFilesProgress, cleanBulkScenarioInputData } from "../../../../components/UserFunctions";

var checkValidFile = true;

const ScenarioFileUpload = (props) => {
    const [isOpen, setIsOPen] = useState(false);
    const [fileSystem, setFileSystem] = useState("s3-filesystem");
    const [simulator, setsimulator] = useState("");
    const [model, setModel] = useState("");

    const [bulkUploadSelect, setBulkUploadSelect] = useState(false);
    const [buttonPushPopUpCleanFiles, setbuttonPushPopUpCleanFiles] = useState(false);
    const [uploadInputFilesStatus, setUploadInputFilesStatus] = useState(false);
    const [uploadInputFileComplete, setUploadInputFileComplete] = useState(false);
    // const [extractImageAndDescriptionFlag, setExtractImageAndDescriptionFlag] = useState(false);

    // const [bulkFileSystem, setBulkFileSystem] = useState("local-filesystem");
    const [imageDescriptionExtractionStatus, setExtractionStatus] = useState(false);
    const [extractionMessage, setExtractionMessage] = useState("");
    const [bulkUploadFiles, setBulkUploadFiles] = useState(false);

    const [buttonPushPopUp, setbuttonPushPopUp] = useState(false);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadBulkScenarioSuccess, setUploadBulkScenarioSuccess] = useState(false);
    const [popupNoInputFiles, setPopupNoInputFiles] = useState(false);
    const [progress, setProgress] = useState(false);
    const [componentStatus, setComponentStatus] = useState(false);
    const [statusInfo, setStatusInfo] = useState({
        totalVariationsCount: 0,
        totalBaseScenarioVariationsGenerated: 0,
        totalBaseScenario: 0,
        totalVariationsUploaded: 0,
        percentageCompleted: 0,
    });

    const loadingTip = "Loading...";

    const data = { simulatorName: simulator, modelName: model, loaderStatus: loading };

    useEffect(() => {
        props.simulatorList();
        props.resetProgress();
        // if (props.bulkInputFilesUploadStatus.uploadStatus) {
        //     // setUploadInputFilesStatus(false);
        //     setUploadInputFileComplete(props.bulkInputFilesUploadStatus.uploadStatus);
        //     console.log("extracting images and description ");
        //     props.extractImagesAndDescription(simulator, model);
        // }
    }, [props.bulkInputFilesUploadStatus.uploadStatus]);

    useEffect(() => {
        if (loading) {
            const timeout = setInterval(() => {
                uploadBulkScenarioFilesProgress("/close_loop/bulk_scenario_file/upload", data).then(
                    (res) => {
                        if (res) {
                            if (res.data.status !== "No_input_files") {
                                if (res.data.status === "in_progress") {
                                    console.log(
                                        "Input files are present.Uploading of scenario variations process in progress "
                                    );
                                    setProgress(true);
                                    setLoading(true);
                                    let output = res.data;
                                    let percentage = 0;
                                    if (output.total_variations_count !== 0) {
                                        percentage = parseInt(
                                            (output.total_variations_uploaded /
                                                output.total_variations_count) *
                                            100
                                        );
                                    }
                                    setStatusInfo({
                                        totalVariationsCount: output.total_variations_count,
                                        totalBaseScenarioVariationsGenerated:
                                            output.total_base_scenario_variations_generated,
                                        totalBaseScenario: output.total_base_scenario,
                                        totalVariationsUploaded: output.total_variations_uploaded,
                                        percentageCompleted: percentage,
                                    });
                                    setShow(!show);
                                    // } else if (res.data.status === "input_files_present") {
                                    //     setShow(!show);
                                    //     setLoading(true);
                                } else if (res.data.status === "success") {
                                    setLoading(false);
                                    setProgress(false);
                                    setShow(!show);
                                    setStatusInfo({
                                        totalVariationsCount: 0,
                                        totalBaseScenarioVariationsGenerated: 0,
                                        totalBaseScenario: 0,
                                        totalVariationsUploaded: 0,
                                        percentageCompleted: 0,
                                    });
                                    setUploadBulkScenarioSuccess(false);
                                    setExtractionStatus(false);
                                    alert(
                                        "Bulk scenario variations upload in completed.."
                                    );
                                    document.getElementById("xoscValidate").innerHTML = "";
                                    document.getElementById("sddValidate").innerHTML = "";
                                    document.getElementById("close_loop_bulk_file").value = "";
                                    document.getElementById("close_loop_bulk_scenario_sdd_upload").value = "";
                                    setUploadInputFileComplete(false);
                                    setUploadInputFilesStatus(false);
                                    setUploadBulkScenarioSuccess(false);
                                    setExtractionStatus(false);
                                    props.resetProgress()
                                    // setExtractionMessage("")
                                    //                                    setUploadInputFileComplete(false)
                                    extractionCallBackFunction("", false)
                                    props.resetExtractImagesAndDesc()
                                    props.bulkInputFilesUploadStatus.uploadStatus = false;
                                    setUploadInputFileComplete(props.bulkInputFilesUploadStatus.uploadStatus)
                                    setExtractionStatus(false)
                                    props.resetUploadStatusState();
                                    document.getElementById("upload_bulk_scenario_button").disabled = true;

                                }
                            } else {
                                setLoading(false);
                                setProgress(false);
                                setShow(!show);
                                // alert("Input files are not present.")
                            }
                        }
                    }
                );
            }, 3000);
            return () => clearInterval(timeout);
        }
    }, [show]);

    useEffect(() => {
        if (uploadInputFilesStatus || progress) {
            const handleTabClose = (event) => {
                return (event.returnValue = "Are you sure you want to exit?");
            };
            window.addEventListener("beforeunload", handleTabClose);
            return () => {
                window.removeEventListener("beforeunload", handleTabClose);
            };
        }
    }, [uploadInputFilesStatus, progress]);

    function isNum(val) {
        return !isNaN(val);
    }
    const handleAttachFile = (e) => {
        e.preventDefault();
        let text;
        let sc_name;
        const uploadInput = document.getElementById("close-loop-upload-files");
        text = uploadInput.files[0].name;

        const fileNameParts = text.split('.').pop() || '';
        console.log(fileNameParts, 'fileExtension')
        //         text = text.split('_')[0]

        //         const firstFiveCharacters = text.slice(0, 5);
        //         const Assessment_code = text.slice(4);
        //         console.log('Assessment_code1', Assessment_code);
        //         let target = firstFiveCharacters[0];
        //         let Scenario_Type = firstFiveCharacters[1];
        //         let Situation1 = firstFiveCharacters[2];
        //         let Situation2 = firstFiveCharacters[3];
        //         console.log('Target =', target, ' ', 'S_Type =', Scenario_Type, ' ', 'Situation1 =', Situation1, ' ', 'Situation2 =', Situation2);
        //         //-------------------------------------------------------------------------------------------
        //         let scenario_mata_data = {
        //             "assessment_code": text.slice(4),
        //             "target_obstacle": firstFiveCharacters[0],
        //             "scenario_Type": firstFiveCharacters[1],
        //             "situation1": firstFiveCharacters[2],
        //             "situation2": firstFiveCharacters[3]
        //         }

        //   console.log("---===========44e",scenario_mata_data)
        // for (let i = 0; i < uploadInput.files.length; i++) {
        //     sc_name = uploadInput.files[i].name;
        //     let var_name;
        //     var_name = sc_name.split(".")[0];
        //     if (sc_name.startsWith("SC_ADHWY")) {
        //         if (var_name.includes("Var")) {
        //             let var_numer;
        //             var_numer = var_name.split("Var")[1];
        //             if (isNum(var_numer)) {
        //                 console.log(var_numer);
        //             } else {
        //                 checkValidFile = false;
        //             }
        //         } else {
        //             checkValidFile = false;
        //         }
        //     } else {
        //         checkValidFile = false;
        //     }
        // }
        if (fileNameParts == 'zip') {
            checkValidFile = true;
        }
        else {
            checkValidFile = false;
        }
        if (checkValidFile === true) {
            text = "valid File";

            const scenarioDescription = document.getElementById("close-loop-scenario-description");
            const description = scenarioDescription.value;
            const scenarioRepresentation = document.getElementById(
                "close-loop-scenario-representation"
            );
            const imageFile = scenarioRepresentation.files[0];
            // const imageName = imageFile.name;
            // const fileName = uploadInput.files[0].name;

            props.setUploadFile(
                uploadInput.files,
                fileSystem,
                description,
                simulator,
                model,
                imageFile,
                //scenario_mata_data
            );
            uploadInput.value = ""; // to clear the current file field
            scenarioDescription.value = ""; // to clear the scenario Description
            scenarioRepresentation.value = ""; // to clear the current image file field
            document.getElementById("demo").innerHTML = "";

        } else {
            checkValidFile = true;
            text =
                "Invalide File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_'<'Variation count'>'.xosc eg. SC_ADHWY_TJP_8b_Var192.xosc";
        }

    };
    
    const validateFileName = (e) => {
        e.preventDefault();
        let text;
        let sc_name;
        const uploadInput = document.getElementById("close-loop-upload-files");
        //-----------------------------------------------------------------------------------
        text = uploadInput.files[0].name;

        const fileNameParts = text.split('.');
        const fileExtension = fileNameParts.pop();
        const zipSizeInBytes = text.byteLength;
        console.log(zipSizeInBytes,"zip")
        
        // const ss=text.size;

        // const s =text = uploadInput.files[0].size;
        // const kilobytes = s / 1024;

        // console.log(s,"zip----")

        // console.log(fileExtension)
        // const firstFiveCharacters = text.slice(0, 5);
        // const underscoreIndex = text.indexOf('_');
        // const Assessment_code = text.slice(4, underscoreIndex);
        // console.log('Assessment_code =', Assessment_code);
        // let target = firstFiveCharacters[0];
        // let Scenario_Type = firstFiveCharacters[1];
        // let Situation1 = firstFiveCharacters[2];
        // let Situation2 = firstFiveCharacters[3];
        // console.log('Target =', target, ' ', 'S_Type =', Scenario_Type, ' ', 'Situation1 =', Situation1, ' ', 'Situation2 =', Situation2);
        //-------------------------------------------------------------------------------------------

        //     for (let i = 0; i < uploadInput.files.length; i++) {
        //         sc_name = uploadInput.files[i].name;
        //         let var_name;
        //         var_name = sc_name.split(".")[0];


        //         if (sc_name.startsWith("SC_ADHWY")) {
        //             if (var_name.includes("Var")) {
        //                 let var_numer;
        //                 var_numer = var_name.split("Var")[1];
        //                 if (isNum(var_numer)) {
        //                     console.log(var_numer);
        //                 } else {
        //                     checkValidFile = false;
        //                 }
        //             } else {
        //                 checkValidFile = false;
        //             }
        //         } else {
        //             checkValidFile = false;
        //         }
        //     }
        //     if (checkValidFile === true) {
        //         text = "valid File";
        //     } else {
        //         checkValidFile = true;
        //         text =
        //             "Invalide File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_'<'Variation count'>'.xosc eg. SC_ADHWY_TJP_8b_Var192.xosc";
        //     }
        //     document.getElementById("demo").innerHTML = text;
        // }

        if (fileExtension == 'zip') {
            checkValidFile = true;
        }
        else {
            checkValidFile = false;
        }
        if (checkValidFile === true) {
            text = "valid File";
        } else {
            checkValidFile = true;
            text =
                "Invalide File. Please upload file with name SC_ADHWY_'<'scenario category'>'_'<'feature'>'_'<'Variation count'>'.xosc eg. SC_ADHWY_TJP_8b_Var192.xosc";
        }
        document.getElementById("demo").innerHTML = text;
    }




    // const openModal = () => {
    //     setIsOPen(true);
    // };

    const closeModal = () => {
        setIsOPen(false);
    };

    const handleCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(true);
    };

    const handleCloseCleanFiles = () => {
        setbuttonPushPopUpCleanFiles(false);
    };

    const CleanFiles = () => {
        if (simulator != "" && model != "") {
            const payload = { simulatorName: simulator, modelName: model };
            cleanBulkScenarioInputData("/clean_bulk_scenario_input_data", payload).then(
                (response) => {
                    if (response.data.data === "success") {
                        alert("Cleaning of bulk scenario variation input folders done. ");
                    } else {
                        alert("Cleaning of the input folder failed. Please try again. ");
                    }
                }
            );
            handleCloseCleanFiles();
            props.resetProgress();
            setLoading(false);
            setProgress(false);
            setStatusInfo({
                totalVariationsCount: 0,
                totalBaseScenarioVariationsGenerated: 0,
                totalBaseScenario: 0,
                percentageCompleted: 0,
            });
            document.getElementById("xoscValidate").innerHTML = "";
            //document.getElementById("sddValidate").innerHTML = "";
            document.getElementById("close_loop_bulk_file").value = "";
            //document.getElementById("close_loop_bulk_scenario_sdd_upload").value = "";
            setUploadInputFilesStatus(false);
            setUploadBulkScenarioSuccess(false);
            setExtractionStatus(false);
            // setExtractionMessage("")
            setUploadInputFileComplete(false)
            extractionCallBackFunction("", false)
            props.resetExtractImagesAndDesc()
            props.resetUploadStatusState()

            // document.getElementById("xoscValidate").innerHTML = "";

            // props.resetUploadStatus();
            // setGenerateSuccess(false);
        }
    };

    var checkXoscValidFile = true;
    var sddValidationFile = true;
    

    const validateBulkFileName = (e) =>{
        let uploadBulkInput = document.getElementById("close_loop_bulk_file");
        let text = uploadBulkInput.files[0].name;
        const fileNameParts = text.split('.');
        const fileExtension = fileNameParts.pop();
        let xoscValidationText;
        xoscValidationText = "valid File";
        
        document.getElementById("xoscValidate").innerHTML = xoscValidationText;
    }
    const handleBulkScenarioUpload = (e) => {
        e.preventDefault();
        const bulkFileSystem = "local-filesystem";
        let xoscValidationText;
        let sddValidationText;
        let sc_name;
        const uploadBulkInput = document.getElementById("close_loop_bulk_file");
        console.log(uploadBulkInput,"nn")
        // for (let i = 0; i < uploadBulkInput.files.length; i++) {
        //     sc_name = uploadBulkInput.files[i].name;
        //     let var_name;
        //     var_name = sc_name.split(".")[0];
        //     if (sc_name.startsWith("SC_ADHWY")) {
        //         if (var_name.includes("Var")) {
        //             let var_numer;
        //             var_numer = var_name.split("Var")[1];
        //             if (isNum(var_numer)) {
        //                 console.log("file name : ", var_numer);
        //             } else {
        //                 checkXoscValidFile = false;
        //             }
        //         } else {
        //             checkXoscValidFile = false;
        //         }
        //     } else {
        //         checkXoscValidFile = false;
        //     }
        // }
        // const sddFileUpload = document.getElementById("close_loop_bulk_scenario_sdd_upload");
        // const sddFile = sddFileUpload.files[0];
        // const sddFileName = sddFileUpload.files[0].name;
        // if (
        //     sddFileName.startsWith("Scenario_Description_Document") &&
        //     sddFileName.endsWith(".xlsx")
        // ) {
        //     sddValidationFile = true;
        // } else {
        //     sddValidationFile = false;
        // }
        // uploadBulkInput.value = "";
        // sddFileUpload.value = "";
       
            xoscValidationText = "valid File";
            sddValidationText = "valid File";
            setUploadInputFilesStatus(true);
            props.uploadInputFilesForValidation(
                uploadBulkInput.files,
                simulator,
                model
            );
        document.getElementById("xoscValidate").innerHTML = "";
        document.getElementById("close_loop_bulk_file").value = "";
    };

    const availableFileSystems = [
        {
            label: "Cloud-FileSystem",
            value: "s3-filesystem",
        },
        {
            label: "Local-FileSystem",
            value: "local-filesystem",
        },
    ];

    let simOptions = [];
    if (props.simulatorListInfo.length > 0) {
        simOptions = props.simulatorListInfo.map((simLabel) => {
            return { label: simLabel, value: simLabel };
        });
        if (simulator === "") {
            setsimulator(simOptions[0].label);
            props.modelList(simOptions[0].label);
        }
    } else {
        simOptions = [];
    }

    let modelOptions = [];
    if (props.modelListInfo.length > 0) {
        modelOptions = props.modelListInfo.map((modelLabel) => {
            return { label: modelLabel, value: modelLabel };
        });
        if (model === "") {
            setModel(modelOptions[0].label);
        }
    } else {
        modelOptions = [];
    }

    const checkBoxSelect = () => {
        if (bulkUploadSelect == false) {
            setBulkUploadSelect(true);
        } else {
            setBulkUploadSelect(false);
        }
    };

    const handleCloseNoInputFiles = () => {
        setPopupNoInputFiles(false);
    };

    const onComponentStatus = () => {
        setComponentStatus(!componentStatus);
    };

    const handleCloseGenerateVariation = () => {
        setbuttonPushPopUp(false);
    };

    const handleBulkUploadVariation = () => {
        setbuttonPushPopUp(true);
    };

    function uploadBulkScenarios() {
        setShow(!show);
        setLoading(true);
        let data = { simulatorName: simulator, modelName: model, loaderStatus: true };
        uploadBulkScenarioFilesProgress("/close_loop/bulk_scenario_file/upload", data).then(
            (res) => {
                if (res.data.status !== "No_input_files") {
                    setShow(!show);
                    setLoading(true);
                    if (res.data.status === "in_progress") {
                        alert("Generation of scenario variations process in progress.");
                    }
                    if (res.data.status === "success") {
                        setLoading(false);
                        setUploadBulkScenarioSuccess(true);
                        setProgress(false);
                        setUploadInputFileComplete(false)
                        checkValidFile = false;
                        alert("Bulk scenario variations upload in completed.");
                    }
                } else {
                    setPopupNoInputFiles(true);
                }
            }
        );
        handleCloseGenerateVariation();
    }

    const extractionCallBackFunction = (data, status) => {
        if (data && Object.keys(data).length !== 0) { // Check if data is defined and not null
            setExtractionStatus(status);
            setExtractionMessage(data);
        }
    };
    

    return (
        <>
            <Spin spinning={loading} tip={loadingTip}>
                <Container className="mt-5">
                    <Row>
                        <Col>
                            <div>
                                {props.simulatorErrorStatus || props.modalErrorStatus ? (
                                    <Alert key="danger" variant="danger">
                                        {props.simulatorErrorStatus || props.modalErrorStatus}
                                    </Alert>
                                ) : undefined}
                            </div>
                            <Card>
                                <Card.Header
                                    className="mb-2"
                                    style={{ backgroundColor: "#757AF7" }}
                                >
                                    <Row>
                                        <Col md={6} sm={5}>
                                            <h4 style={{ color: "#FFFFFF" }}>
                                                Upload Scenario File(s)
                                            </h4>
                                        </Col>
                                        <Col
                                            md={6}
                                            sm={5}
                                            style={{
                                                textAlign: "right",
                                                color: "#FFFFFF",
                                                fontSize: "1.1rem",
                                            }}
                                        >
                                            <div className="form-check">
                                                <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    value=""
                                                    id="flexCheckDefault"
                                                    onClick={checkBoxSelect}
                                                />
                                                <label
                                                    class="form-check-label"
                                                    for="flexCheckDefault"
                                                >
                                                    Bulk scenario upload
                                                </label>
                                            </div>
                                        </Col>
                                        {/* <Col md={3} sm={7}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id="sh-utility-component">
                                                        <strong>
                                                            For bulk upload create a json file with all
                                                            the files path in it. And upload the same
                                                            file to download sh utility file
                                                        </strong>
                                                    </Tooltip>
                                                }
                                            >
                                                <Button
                                                    type="button"
                                                    style={{
                                                        backgroundColor: "#FFFFFF",
                                                        color: "#757AF7",
                                                    }}
                                                    onClick={openModal}
                                                >
                                                    Download sh utility
                                                </Button>
                                            </OverlayTrigger>
                                        </Col> */}
                                    </Row>
                                </Card.Header>
                                {bulkUploadSelect === false ? (
                                    <Card.Body>
                                        <Form onSubmit={handleAttachFile}>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>File(s) :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <input
                                                                        type="file"
                                                                        webkitdirectory
                                                                        accept=".zip"
                                                                        onChange={(e) => {
                                                                            validateFileName(e)
                                                                        }}
                                                                        multiple
                                                                        id="close-loop-upload-files"
                                                                        data-testid="close-loop-upload-files"
                                                                        required
                                                                    />
                                                                    <p
                                                                        style={{ color: "#FF0000" }}
                                                                        id="demo"
                                                                    ></p>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>File System :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={fileSystem}
                                                                        onChange={(e) =>
                                                                            setFileSystem(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        {availableFileSystems.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`file-system-${index}`}
                                                                                    value={
                                                                                        item.value
                                                                                    }
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Description :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        required
                                                                        id="close-loop-scenario-description"
                                                                        data-testid="close-loop-scenario-description"
                                                                    ></Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Simulator :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={simulator}
                                                                        onChange={(e) => {
                                                                            setsimulator(
                                                                                e.target.value
                                                                            );
                                                                            props.modelList(
                                                                                e.target.value
                                                                            );
                                                                        }}
                                                                    >
                                                                        {simOptions.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`simulator-${index}`}
                                                                                    value={
                                                                                        item.value
                                                                                    }
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Model :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={model}
                                                                        onChange={(e) =>
                                                                            setModel(e.target.value)
                                                                        }
                                                                    >
                                                                        {modelOptions.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`model-${index}`}
                                                                                    value={
                                                                                        item.value
                                                                                    }
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Image File :</h4>
                                                                </Col>
                                                                <Col>
                                                                    <input
                                                                        type="file"
                                                                        id="close-loop-scenario-representation"
                                                                        data-testid="close-loop-scenario-representation"
                                                                        accept="image/*"
                                                                        required
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="mt-2">
                                                <Col>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col className="text-center">
                                                                <Button
                                                                    type="submit"
                                                                    data-testid="close-loop-scenario-form"
                                                                    style={{
                                                                        backgroundColor: "#757AF7",
                                                                        color: "#FFFFFF",
                                                                    }}
                                                                >
                                                                    Upload
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                ) : (
                                    <Card.Body>
                                        <Form onSubmit={handleBulkScenarioUpload}>
                                            <Row>
                                                <Col
                                                    md={1}
                                                    sm={7}
                                                    style={{
                                                        display: "flex",
                                                        marginLeft: "1.5rem",
                                                        paddingBottom: "0.5rem",
                                                    }}
                                                >
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id="reset-folder">
                                                                <strong>
                                                                    It will do clean up of bulk
                                                                    scenario variation input folder
                                                                </strong>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Button
                                                            type="submit"
                                                            style={{
                                                                backgroundColor: "#757AF7",
                                                                color: "#FFFFFF",
                                                            }}
                                                            onClick={handleCleanFiles}
                                                            data-test="clickComponent"
                                                        >
                                                            Reset
                                                        </Button>
                                                    </OverlayTrigger>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Card>
                                                        {/* <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Uploading Status</h4>
                                                                </Col>
                                                                <Col
                                                                    style={{
                                                                        border: "1px solid #e5dada",
                                                                        backgroundColor: "#e2e3ff",
                                                                    }}
                                                                >
                                                                    {!uploadBulkScenarioSuccess ? (
                                                                        !uploadInputFilesStatus ? (
                                                                            "Please choose the files to be uploaded and then click on upload input files"
                                                                        ) : !uploadInputFileComplete ? (
                                                                            <p>
                                                                                Uploading xosc and
                                                                                sdd file in progress
                                                                            </p>
                                                                        ) : !imageDescriptionExtractionStatus ? (
                                                                            <p>
                                                                                Uploading xosc and
                                                                                sdd file completed.
                                                                                Extracting images
                                                                                and description from
                                                                                sdd file in progress{" "}
                                                                                <MiniLoader />
                                                                            </p>
                                                                        ) : (
                                                                            extractionMessage
                                                                        )
                                                                    ) : loading ? (
                                                                        <p>
                                                                            Uploading bulk
                                                                            scenario's in progress
                                                                            
                                                                        </p>
                                                                    ) : (
                                                                        <p>
                                                                            Uploading bulk scenarios
                                                                            successfully completed
                                                                        </p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item> */}
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>
                                                                        Select scenario ZIP files
                                                                    </h4>
                                                                </Col>
                                                                <Col>
                                                                    <input
                                                                        type="file"
                                                                       accept=".zip"
                                                                        className="form-control"
                                                                        multiple
                                                                        id="close_loop_bulk_file"
                                                                        data-testid="close_loop_bulk_file"
                                                                        onChange={(e) => validateBulkFileName(e)}
                                                                        style={{ border: "0rem" }}
                                                                        required
                                                                    />
                                                                    <p
                                                                        style={{ color: "#FF0000" }}
                                                                        id="xoscValidate"
                                                                    ></p>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        {/* <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>
                                                                        Select scenario sdd file
                                                                    </h4>
                                                                </Col>
                                                                <Col>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        // multiple
                                                                        id="close_loop_bulk_scenario_sdd_upload"
                                                                        style={{ border: "0rem" }}
                                                                        required
                                                                    />
                                                                    <p
                                                                        style={{ color: "#FF0000" }}
                                                                        id="sddValidate"
                                                                    ></p>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item> */}
                                                        {/* <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>File System</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={bulkFileSystem}
                                                                        onChange={(e) =>
                                                                            setBulkFileSystem(
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        {availableFileSystems.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`file-system-${index}`}
                                                                                    value={item.value}
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item> */}
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Simulator</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={simulator}
                                                                        onChange={(e) => {
                                                                            setsimulator(
                                                                                e.target.value
                                                                            );
                                                                            props.modelList(
                                                                                e.target.value
                                                                            );
                                                                        }}
                                                                    >
                                                                        {simOptions.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`simulator-${index}`}
                                                                                    value={
                                                                                        item.value
                                                                                    }
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                        <ListGroup.Item>
                                                            <Row>
                                                                <Col>
                                                                    <h4>Model</h4>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        value={model}
                                                                        onChange={(e) =>
                                                                            setModel(e.target.value)
                                                                        }
                                                                    >
                                                                        {modelOptions.map(
                                                                            (item, index) => (
                                                                                <option
                                                                                    key={`model-${index}`}
                                                                                    value={
                                                                                        item.value
                                                                                    }
                                                                                >
                                                                                    {item.label}
                                                                                </option>
                                                                            )
                                                                        )}
                                                                    </Form.Control>
                                                                </Col>
                                                            </Row>
                                                        </ListGroup.Item>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <Row className="mt-2">
                                                <Col>
                                                    <ListGroup.Item>
                                                        <Row>
                                                            <Col className="text-center">
                                                                {/* <Button
                                                                    type="submit"
                                                                    data-testid="close-loop-scenario-form"
                                                                    style={{
                                                                        backgroundColor: "#757AF7",
                                                                        color: "#FFFFFF",
                                                                        margin: "0.5rem",
                                                                    }}
                                                                >
                                                                    Upload Input files
                                                                </Button> */}
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip>
                                                                            <strong>
                                                                                Please select
                                                                                scenarios in zip file
                                                                            </strong>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Button
                                                                        type="submit"
                                                                        data-testid="close-loop-scenario-form"
                                                                        style={{
                                                                            backgroundColor:
                                                                                "#757AF7",
                                                                            color: "#FFFFFF",
                                                                            margin: "0.5rem",
                                                                        }}
                                                                        disabled={
                                                                            uploadBulkScenarioSuccess || uploadInputFileComplete
                                                                        }
                                                                    >
                                                                        Upload Input files
                                                                    </Button>
                                                                </OverlayTrigger>
                                                                {/* <Button
                                                                    type="button"
                                                                    data-testid="close-loop-scenario-form"
                                                                    style={{
                                                                        backgroundColor: "#757AF7",
                                                                        color: "#FFFFFF",
                                                                        margin: "0.5rem",
                                                                    }}
                                                                    id="upload_bulk_scenario_button"
                                                                    disabled={
                                                                        !imageDescriptionExtractionStatus ||
                                                                        uploadBulkScenarioSuccess
                                                                    }
                                                                    onClick={
                                                                        handleBulkUploadVariation
                                                                    }
                                                                >
                                                                    Upload Bulk Scenarios
                                                                </Button> */}-
                                                                {/* <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="sh-utility-component">
                                                                            <strong>
                                                                                For bulk upload create a
                                                                                json file with all the
                                                                                files path in it. And
                                                                                upload the same file to
                                                                                download sh utility file
                                                                            </strong>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <Button
                                                                        type="button"
                                                                        data-testid="close-loop-scenario-form"
                                                                        style={{
                                                                            backgroundColor: "#757AF7",
                                                                            color: "#FFFFFF",
                                                                            margin: "0.5rem",
                                                                        }}
                                                                        disabled={!extractionStatus}
                                                                        onClick={uploadBulkScenarios}
                                                                    >
                                                                        Upload Bulk Scenarios
                                                                    </Button>
                                                                </OverlayTrigger> */}
                                                            </Col>
                                                        </Row>
                                                    </ListGroup.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card.Body>
                                )}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Spin>
            {buttonPushPopUpCleanFiles ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseCleanFiles}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>Do you want to clean all the files ?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%", color: "#FFFFFF" }}
                            onClick={CleanFiles}
                        >
                            Yes
                        </Button>
                        <Button
                            className="btn"
                            style={{ marginRight: "40%", backgroundColor: "red", color: "#FFFFFF" }}
                            onClick={handleCloseCleanFiles}
                        >
                            No
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {bulkUploadSelect === false ? (
                <UploadProgress />
            ) : !imageDescriptionExtractionStatus ? (
                <UploadBulkInputProgress extractionStatus={extractionCallBackFunction} />
            ) : undefined}
            {isOpen && <UtilityFormModal isOpen={isOpen} closeModal={closeModal} />}
            {progress ? (
                <Modal isOpen={true}>
                    <ModalHeader>
                        {/* <Button
                            type="submit"
                            style={{
                                backgroundColor: "#757AF7",
                                color: "#FFFFFF",
                            }}
                            onClick={handleCleanFiles}
                            data-test="clickComponent"
                        >
                            Stop
                        </Button> */}
                    </ModalHeader>
                    <ModalBody>
                        <h3>Bulk uploading scenario variation</h3>
                        <Progress
                            strokeColor={{
                                from: "#757AF7",
                                to: "#B0FF44",
                            }}
                            percent={statusInfo.percentageCompleted}
                            status="active"
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            data-toggle="collapse"
                            data-target="#components-card"
                            aria-controls="components-card"
                            onClick={onComponentStatus}
                            style={{
                                border: "0px",
                                color: "#FFFFFF",
                                backgroundColor: "#9296ff",
                            }}
                        >
                            <i
                                className={
                                    componentStatus
                                        ? "fas fa-angle-double-up"
                                        : "fas fa-angle-double-down"
                                }
                            />
                        </Button>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="collapse" id="components-card">
                                    <p style={{ margin: "0px" }}>
                                        Total Number of Base Scenarios :{" "}
                                        {statusInfo.totalVariationsCount}
                                    </p>
                                    {/* <p style={{ margin: "0px" }}>
                                        No of Base Scenario Variations Uploaded :{" "}
                                        {statusInfo.totalBaseScenarioVariationsGenerated}
                                    </p> */}
                                    <p style={{ margin: "0px" }}>
                                        Total Uploaded Variations Count :{" "}
                                        {statusInfo.totalVariationsUploaded}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {buttonPushPopUp ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseGenerateVariation}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>Do you want to upload the scenario variations ?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%", color: "#FFFFFF" }}
                            onClick={uploadBulkScenarios}
                        >
                            Yes
                        </Button>
                        <Button
                            className="btn"
                            style={{ marginRight: "40%", backgroundColor: "red", color: "#FFFFFF" }}
                            onClick={handleCloseGenerateVariation}
                        >
                            No
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
            {popupNoInputFiles ? (
                <Modal isOpen={true}>
                    <ModalHeader
                        toggle={handleCloseNoInputFiles}
                        style={{ backgroundColor: "#753DFF" }}
                    ></ModalHeader>
                    <ModalBody>
                        <p>
                            There are no input files. please upload required input files to proceed
                            bulk scenario variations
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ marginLeft: "70%" }}
                            onClick={handleCloseNoInputFiles}
                        >
                            Ok
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined}
        </>
    );
};

ScenarioFileUpload.propTypes = {
    // openModal: PropTypes.func,
    simulatorListInfo: PropTypes.array,
    modelListInfo: PropTypes.array,
    simulatorErrorStatus: PropTypes.string,
    modalErrorStatus: PropTypes.string,
    setUploadFile: PropTypes.func,
    simulatorList: PropTypes.func,
    modelList: PropTypes.func,
    uploadInputFilesForValidation: PropTypes.func,
    extractImagesAndDescription: PropTypes.func,
    // uploadBulkScenarioFiles: PropTypes.func,
};

const mapStateToProps = (state) => ({
    simulatorListInfo: state.DropDownSimulatorData.simulatorListInfo,
    modelListInfo: state.DropDownModelData.modelListInfo,
    simulatorErrorStatus: state.DropDownSimulatorData.error,
    modalErrorStatus: state.DropDownModelData.error,
    bulkInputFilesUploadStatus: state.bulkInputFilesUploadStatusReducer,
    extractImagesAndDescriptionMessage:
        state.extractImagesAndDescriptionReducer.extractionStatusData,
    extractImagesAndDescriptionStatus: state.extractImagesAndDescriptionReducer.extractionStatus,
    // uploadBulkScenarioFilesLoader: state.uploadBulkScenarioFilesReducer.loading,
    // uploadBulkScenarioFilesStatus: state.uploadBulkScenarioFilesReducer.uploadStaus,
});

const mapDispatchToProps = (dispatch) => ({
    setUploadFile: (files, fileSystem, description, simulator, model, imageFile) =>
        dispatch(setUploadFile(files, fileSystem, description, simulator, model, imageFile)),
    simulatorList: () => dispatch(fetchSimulatorInfo()),
    modelList: (simulator) => dispatch(fetchModelInfo(simulator)),
    resetProgress: () => dispatch(resetFileUpload()),

    uploadInputFilesForValidation: (scenarioFiles, simulator, model) =>
        dispatch(
            uploadInputFilesForValidation(scenarioFiles, simulator, model)
        ),
    extractImagesAndDescription: (simulator, model) =>
        dispatch(extractImagesAndDescription(simulator, model)),
    // uploadBulkScenarioFiles: (simulator, model, loader) =>
    //     dispatch(uploadBulkScenarioFiles(simulator, model, loader)),
    resetExtractImagesAndDesc: () => dispatch(resetExtractImagesAndDescription()),
    resetUploadStatusState: () => dispatch(resetUploadStatus())
});

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioFileUpload);